import AscMaintenanceListContainer from './containers/AscMaintenanceListContainer'
import { PERMISSION_LEVEL_CONSTS, RESOURCES } from '@/utilities/appConsts'

const maintenanceRouter = {
  icon: 'mdi-alert-circle',
  path: '/maintenance',
  name: 'Maintenance Issues',
  display: true,
  component: AscMaintenanceListContainer,
  meta: {
    primaryNavigation: true,
    requiresResourcePermission: {
      resource: RESOURCES.MAINTENANCE_REC,
      permissionLevel: PERMISSION_LEVEL_CONSTS.READ,
    },

    tooltip: 'View all maintenance recommendations.',
    breadcrumbs: [
      {
        text: 'Home',
        to: '/',
      },
      {
        text: 'Maintenance Issues',
      },
    ],
  },
  children: [],
}

export default maintenanceRouter
